import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ProjectNavbar from "../../../components/projectNavbar/ProjectNavbar";
import Footer from "../../../components/footer/Footer";
import "./FireCommandPage.css";

function FireCommandPage() {
  const { t } = useTranslation();
  const project = t("fireCommandPage", { returnObjects: true });
  const [showBoot, setShowBoot] = useState(true);
  const [bootProgress, setBootProgress] = useState(0);
  const [showDots, setShowDots] = useState(true);

  useEffect(() => {
    // Progress bar animation
    const progressInterval = setInterval(() => {
      setBootProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 1;
      });
    }, 50);

    // Dots animation
    const dotsInterval = setInterval(() => {
      setShowDots((prev) => !prev);
    }, 500);

    setTimeout(() => {
      setShowBoot(false);
    }, 5500);

    return () => {
      clearInterval(progressInterval);
      clearInterval(dotsInterval);
    };
  }, []);

  return (
    <div className="firecommandpage">
      {showBoot && (
        <div className="firecommand-boot">
          <div className="firecommand-boot-content">
            <div className="emergency-badge">
              <div className="badge-outer">
                <div className="badge-inner">
                  <div className="badge-star">
                    <div className="star-point"></div>
                    <div className="star-point"></div>
                    <div className="star-point"></div>
                    <div className="star-point"></div>
                  </div>
                  <div className="badge-center">FC</div>
                </div>
              </div>
              <div className="siren-light siren-left"></div>
              <div className="siren-light siren-right"></div>
            </div>
            <div className="system-status">
              <div className="status-line">
                <span className="status-icon">▸</span>
                <span>Gestión de Incidentes</span>
                <span className="status-ok">[ACTIVO]</span>
              </div>
              <div className="status-line">
                <span className="status-icon">▸</span>
                <span>Control de Unidades</span>
                <span className="status-ok">[LISTO]</span>
              </div>
              <div className="status-line">
                <span className="status-icon">▸</span>
                <span>Mapa de Zonas de Riesgo</span>
                <span className="status-ok">[ONLINE]</span>
              </div>
            </div>
            <p className="firecommand-text">FIRECOMMAND SYSTEM</p>
            <div className="firecommand-progress-container">
              <div className="progress-label">
                Cargando sistema{showDots ? "..." : "   "}
                <span className="progress-percent">{bootProgress}%</span>
              </div>
              <div className="firecommand-progress-bar">
                <div
                  className="firecommand-progress-fill"
                  style={{ width: `${bootProgress}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ProjectNavbar />

      <main className="firecommandpage-content">
        {/* Encabezado y descripción */}
        <section className="firecommandpage-header">
          <h1>{project.title}</h1>
          <p>{project.description.part1}</p>
          <br />
          <p>{project.description.part2}</p>
        </section>

        {/* Sección de imágenes */}
        <section className="firecommandpage-images">
          <div className="firecommand-images-container">
            <div className="firecommand-images-row">
              {project.images.slice(0, 2).map((img, index) => (
                <img
                  key={index}
                  className="firecommand-image"
                  src={img.src}
                  alt={img.alt}
                />
              ))}
            </div>
            <div className="firecommand-images-row">
              {project.images.slice(2, 4).map((img, index) => (
                <img
                  key={index + 2}
                  className="firecommand-image"
                  src={img.src}
                  alt={img.alt}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Columnas */}
        <section className="firecommandpage-columns">
          {project.columns.map((col, index) => (
            <div key={index} className="firecommand-column">
              <h2>{col.title}</h2>
              <p>{col.description}</p>
              <div className="firecommand-buttons">
                {col.buttons.map((btn, i) => (
                  <a
                    key={i}
                    className="firecommand-btn"
                    href={btn.href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {btn.label}
                  </a>
                ))}
              </div>
              {project.postData && (
                <p className="firecommand-postdata">{project.postData}</p>
              )}
            </div>
          ))}
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default FireCommandPage;
